<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="edit-subscription-commission-agreement-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Edit Subscription Commission Agreement
            </h4>
          </div>

          <div class="modal-body">
            <text-form-group
                v-model="data.commission"
                name="commission"
                label="Commission"
                :error="getError('commission')"
            ></text-form-group>

            <number-form-group
                v-model="data.interval_start"
                name="interval_start"
                label="Interval Start"
                :error="getError('interval_start')"
            ></number-form-group>

            <number-form-group
                v-model="data.interval_end"
                name="interval_end"
                label="Interval End"
                :error="getError('interval_end')"
            ></number-form-group>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import NumberFormGroup from '@/vendor/forms/FormGroups/Block/Number'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {NumberFormGroup, TextFormGroup},

  mixins: [Errors],

  props: {
    subscriptionCommissionAgreement: {
      required: true
    }
  },

  data() {
    return {
      data: {}
    }
  },

  watch: {
    subscriptionCommissionAgreement() {
      this.data = {...this.subscriptionCommissionAgreement.attributes}
    }
  },

  mounted() {
    this.listenForClose()
  },


  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.put('/api/v2/subscription-commission-agreements/' + this.subscriptionCommissionAgreement.id, this.data)
          .then(response => {
            notify.success('The subscription commission agreement was saved')

            this.$emit('updated', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}
    }
  }
}
</script>
